import styled, { css } from 'styled-components';
import { spacer8, spacer12 } from '@spotify-internal/encore-foundation';
import VisuallyHidden from "../VisuallyHidden";
import { typeStyleBody2, fontWeightBold } from "../../styles";

var textStyles = function textStyles() {
  return css(["", ";font-weight:", ";border-bottom:2px solid transparent;display:inline-block;line-height:1;padding:", " ", " ", ";", ";"], typeStyleBody2, fontWeightBold, spacer8, spacer8, spacer12, function (props) {
    return props.active && css(["border-color:currentColor;"]);
  });
};

export var VisibleText = styled.span.withConfig({
  displayName: "Text__VisibleText",
  componentId: "sc-1nabn2p-0"
})(["", ";"], textStyles());
export var VisuallyHiddenText = styled(VisuallyHidden).withConfig({
  displayName: "Text__VisuallyHiddenText",
  componentId: "sc-1nabn2p-1"
})(["", ";"], textStyles());